import ReactECharts from 'echarts-for-react';
import { Box, Typography } from '@mui/material';

const SERIES_COLORS_0 = ['#03407b', '#1a7ac4', '#f59e0b', '#10b981'];
const SERIES_COLORS_1 = ['#7c3aed', '#03407b', '#f59e0b', '#10b981'];

const SERIES_0 = [
  { key: 'Notes',            label: 'Notes' },
  { key: 'Nouvelles Missions', label: 'Nouvelles Missions' },
  { key: 'Envois',           label: 'Envois' },
  { key: 'Signatures',       label: 'Signatures' },
];

const SERIES_1 = [
  { key: 'Prequalif',        label: 'Préqualif' },
  { key: 'Revelations',      label: 'Envois Client' },
  { key: 'Propales',         label: 'Propales' },
  { key: 'Signatures',       label: 'Signatures' },
];

function MonthlyEvolutionChart({ data, index }) {
  if (!data?.length) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={300}>
        <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>Aucune donnée</Typography>
      </Box>
    );
  }

  const seriesDefs = index === 0 ? SERIES_0 : SERIES_1;
  const colors = index === 0 ? SERIES_COLORS_0 : SERIES_COLORS_1;
  const months = data.map((d) => d.month);

  const series = seriesDefs.map((s, i) => ({
    name: s.label,
    type: 'line',
    smooth: true,
    symbol: 'circle',
    symbolSize: 6,
    lineStyle: { width: 2.5, color: colors[i] },
    itemStyle: { color: colors[i] },
    areaStyle: {
      color: {
        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
        colorStops: [
          { offset: 0, color: colors[i] + '28' },
          { offset: 1, color: colors[i] + '00' },
        ],
      },
    },
    data: data.map((d) => d[s.key] ?? 0),
    emphasis: { focus: 'series' },
  }));

  const option = {
    color: colors,
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1e293b',
      borderColor: 'transparent',
      textStyle: { color: '#f8fafc', fontSize: 12 },
    },
    legend: {
      bottom: 0,
      icon: 'roundRect',
      itemWidth: 12,
      itemHeight: 6,
      textStyle: { color: '#64748b', fontSize: 12 },
    },
    grid: { left: 12, right: 12, top: 20, bottom: 48, containLabel: true },
    xAxis: {
      type: 'category',
      data: months,
      boundaryGap: false,
      axisLabel: { color: '#64748b', fontSize: 11 },
      axisLine: { lineStyle: { color: '#e2e8f0' } },
      axisTick: { show: false },
    },
    yAxis: {
      type: 'value',
      axisLabel: { color: '#94a3b8', fontSize: 11 },
      splitLine: { lineStyle: { color: '#f1f5f9', type: 'dashed' } },
      axisLine: { show: false },
    },
    series,
  };

  return <ReactECharts option={option} style={{ height: 360, width: '100%' }} notMerge opts={{ renderer: 'canvas', width: 'auto', height: 'auto' }} />;
}

export default MonthlyEvolutionChart;
